const socketUrl =
  process.env.NODE_ENV === "production"
    ? "https://sprint-spark.herokuapp.com/"
    : process.env.REACT_APP_SOCKET_URL

export { socketUrl }
